import bHDStar from "../../assets/images/BHDStar.jpg";
import cgvS from "../../assets/images/CGV.jpg";
import cineStar from "../../assets/images/CineStar.jpg";
import galaxy from "../../assets/images/Galaxy.jpg";
import lotteCinima from "../../assets/images/LotteCinima.jpg";
import megaGS from "../../assets/images/MegaGS.jpg";

export const listCinema = [
    { name: "BHDStar", img: bHDStar },
    { name: "CGV", img: cgvS },
    { name: "CineStar", img: cineStar },
    { name: "Galaxy", img: galaxy },
    { name: "LotteCinima", img: lotteCinima },
    { name: "MegaGS", img: megaGS },
];
